(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4122],{

/***/ 3270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DetailsWithPhoto; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





function DetailsWithPhoto(_ref) {
  var details = _ref.details,
      image = _ref.image;
  if (!details) return null;
  var photo = image !== null && image !== void 0 && image.file.data[0] ? image : null;
  var description = details.split('\n');
  var lis = [];

  for (var i = 1; i < details.length; i += 1) {
    lis.push( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[i]
    }, i));
  }

  var myLoader = function myLoader(_ref2) {
    var src = _ref2.src;
    return src;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: description[0]
    }), photo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      loader: myLoader,
      src: photo.file.data[0].attributes.url,
      height: 900,
      width: 1200,
      layout: "responsive"
    }) : null, lis]
  });
}

/***/ }),

/***/ 36389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Term; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/shared/AddFaq.js
var AddFaq = __webpack_require__(30155);
// EXTERNAL MODULE: ./components/shared/ArticleList.tsx
var ArticleList = __webpack_require__(54242);
// EXTERNAL MODULE: ./components/shared/DetailsWithPhoto.tsx
var DetailsWithPhoto = __webpack_require__(3270);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/termscontent/description.tsx





function Description(_ref) {
  var term = _ref.term;
  var _term$attributes = term.attributes,
      description = _term$attributes.description,
      image = _term$attributes.image;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      md: 16,
      xs: 24,
      style: {
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '22px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DetailsWithPhoto/* default */.Z, {
        details: description,
        image: image
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      span: 6
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
;// CONCATENATED MODULE: ./components/termscontent/heading.tsx






var Title = typography/* default.Title */.Z.Title;
function Heading(_ref) {
  var term = _ref.term;
  var title = term.attributes.seo_meta.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      className: "page-wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 22,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
          level: 3,
          style: {
            fontWeight: 'normal',
            fontSize: '24px',
            lineHeight: '29px',
            letterSpacing: '-0.015em'
          },
          children: ["Common Financial Terms & Concepts", /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
            size: "large",
            type: "primary",
            style: {
              "float": 'right'
            },
            source: "ft-share-button",
            children: "Share"
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      className: "page-wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 20,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          level: 1,
          children: title
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/termscontent/index.tsx








function TermsContent(_ref) {
  var term = _ref.term;
  var articles = term.attributes.articles.data;
  var input = {
    article_type: 'faq',
    financial_term: term.id
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      span: 24,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading, {
        term: term
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        term: term
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddFaq/* default */.Z, {
          input: input
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
          articles: articles
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/financial_literacy/[slug].tsx










var title = function title(name) {
  return "".concat(name, " Defination, meaning, examples");
};

var description = function description(name) {
  return "".concat(name, " meaning, examples");
};

var __N_SSP = true;
function Term(props) {
  var _image$file;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.nav_calculators.data,
      financialTerm = pageData.selected_term.data,
      allPages = pageData.all_pages.data;
  var term = financialTerm[0];
  var _term$attributes = term.attributes,
      name = _term$attributes.name,
      seoMeta = _term$attributes.seo_meta,
      image = _term$attributes.image;

  var _ref = seoMeta || {},
      recordTitle = _ref.title,
      recordDescription = _ref.description;

  var pageTitle = title(name);
  var pageDescription = description(name);
  var images = [];

  if (image !== null && image !== void 0 && (_image$file = image.file) !== null && _image$file !== void 0 && _image$file.data) {
    var _image$file$data$, _image$file2, _image$file2$data$;

    var availableImage = ((_image$file$data$ = image.file.data[0]) === null || _image$file$data$ === void 0 ? void 0 : _image$file$data$.attributes.formats.large) || ((_image$file2 = image.file) === null || _image$file2 === void 0 ? void 0 : (_image$file2$data$ = _image$file2.data[0]) === null || _image$file2$data$ === void 0 ? void 0 : _image$file2$data$.attributes.url);
    images = [availableImage];
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: recordTitle || pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: recordDescription || pageDescription
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      title: pageTitle,
      images: images,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TermsContent, {
      term: term
    })]
  });
}

/***/ }),

/***/ 16043:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/financial_literacy/[slug]",
      function () {
        return __webpack_require__(36389);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pickAttrs; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,2769,6568,5045,5239,1096,8182,3492,3337,9774,2888,179], function() { return __webpack_exec__(16043); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);